// Onboarding-shell constants (VER-368). The stream-classification helpers live in
// @/components/classification/streams.helpers — shared with the review queue and
// the Categorizar drawer, which mount the same cards.

export const ONBOARDING_STEPS = [
  { n: 1, label: 'Validação' },
  { n: 2, label: 'Conexões' },
  { n: 3, label: 'Categorias' },
  { n: 5, label: 'Pronto' },
] as const;

/** The step vocabulary by name — every position in the flow reads through this,
 * so the next renumber is a one-file change (mirrors Domain OnboardingStep).
 * `n` values are WIRE positions: the API's Domain vocabulary still reserves 4
 * for the removed Recorrentes step, so the flow writes 1,2,3,5 and the stepper
 * renders display positions by index. Collapsing 5→4 is a coordinated
 * cross-repo renumber, not a frontend edit. */
export const STEP = {
  validation: 1,
  connections: 2,
  streams: 3,
  done: 5,
} as const;

/** The wire position of the RETIRED Recorrentes step. A user whose server
 * resume position still points there had already finished Categorias, so the
 * flow resumes them on Pronto instead of a step that no longer renders. */
const RETIRED_RECURRING_STEP = 4;

export function resumeStepFromServer(serverStep: number): number {
  return serverStep === RETIRED_RECURRING_STEP ? STEP.done : serverStep;
}

/** The consent term-set version this build SHOWS. Must equal the API's
 * Consent:TermsVersion or every accept 409s ("Os termos foram atualizados…") —
 * the version-equality check working as designed, which makes bumping this part
 * of a coordinated release (VER-383). 2026-08-28 = the VER-379 + VER-398 set: Termos +
 * Política including the Open Finance processing clause (§4). Every version is
 * frozen in core.api's docs/consent/VERSIONS.md — append a row there when
 * bumping this. */
export const CONSENT_VERSION = '2026-08-28';

/**
 * Days left in the trial from subscriptions/me's `trialEndsAt` — the product
 * source of truth (backend Billing:TrialDays). Null when there is no live trial
 * claim to make: no data yet, no trial, or already expired. Callers hide the
 * trial copy on null instead of guessing a number (the UI once said 30 while
 * the backend enforced 100 and the product meant 7).
 */
export function trialDaysLeft(trialEndsAt: string | null | undefined, now = Date.now()): number | null {
  if (!trialEndsAt) return null;
  const endsAt = new Date(trialEndsAt).getTime();
  if (!Number.isFinite(endsAt) || endsAt <= now) return null;
  return Math.ceil((endsAt - now) / 86_400_000);
}
